import React from "react";
import './DocumentCard.scoped.scss';
import fileIcon from "../../../../assets/images/svg/file.svg";
import downloadIcon from "../../../../assets/images/svg/download.svg";
import eyeIcon from "../../../../assets/images/svg/eye-new.svg";
import {Image} from "../../images";
import {formatDate} from "../../../../formatters";
import {downloadPDF} from "../../../../utils/downloadPDF";
import {cn} from "../../../../utils";

interface Props {
    title: string;
    date: Date;
    fileUrl: string;
    fileName?: string;
    className?: string;
}

const DocumentCard = ({title, date, fileUrl, fileName, className}: Props) => {
  const handleDownload = () => {
    downloadPDF(fileUrl, fileName ?? title);
  };

  const handleView = () => {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={cn("document-card", className)}>
      <Image className="document-card__icon" src={fileIcon} alt=""/>
      <div className="document-card__info">
        <div className="document-card__title">{title}</div>
        <div className="document-card__date">{formatDate(date)}</div>
      </div>
      <div className="document-card__actions">
        <button type="button" className="document-card__action" onClick={handleDownload} aria-label="Скачать">
          <Image src={downloadIcon} alt=""/>
        </button>
        <button type="button" className="document-card__action" onClick={handleView} aria-label="Просмотреть">
          <Image src={eyeIcon} alt=""/>
        </button>
      </div>
    </div>
  );
};

export default DocumentCard;
